import { useEffect, useRef, useState } from "react";

export const useHandleClickOutside = (initialState = false) => {
  const [isOpen, setIsOpen] = useState(initialState);
  const ref = useRef();

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("click", handleOutsideClick);

    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, [ref]);

  return { isOpen, setIsOpen, ref };
};
